import { api } from "./api";

const quotationitemApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getQuotationItems: builder.query({
      query: () => "quotation",
      providesTags: ["quotation"],
    }),
    addQuotationItem: builder.mutation({
      query: (newCategory) => ({
        url: "quotation",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["quotation"],
    }),
    removeQuotationItem: builder.mutation({
      query: (id) => ({
        url: `quotations?qto_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["quotation"],
    }),
    editQuotationItem: builder.mutation({
      query: (editData) => ({
        url: `quotation`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["quotation"],
    }),
  }),
});

export const {
  useGetQuotationItemsQuery,
  useAddQuotationItemMutation,
  useRemoveQuotationItemMutation,
  useEditQuotationItemMutation,
} = quotationitemApi;
